export enum IncidentType {
  ACCIDENT = 'ACCIDENT',
  DELAYED = 'DELAYED',
  DAMAGED_CONTAINER = 'DAMAGED_CONTAINER',
  DEFER = 'DEFER'
}
